module.exports = __webpack_public_path__ + "img/DSC00532-cropped-large.c5782cc9.webp";